import { render, staticRenderFns } from "./QuoteTemplateSideMenu.vue?vue&type=template&id=0a88ff72"
import script from "./QuoteTemplateSideMenu.vue?vue&type=script&lang=js"
export * from "./QuoteTemplateSideMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports